module.exports = __webpack_public_path__ + "8a5508029a13268352cafbaece288e68.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/news/jetstar/jetstar-november-2015-page-002.jpg
 ** module id = 467
 ** module chunks = 0
 **/